// ======== plugin import ====== //
import React,{useEffect, useLayoutEffect} from 'react'
import { useLocation } from 'react-router-dom';
// ========== component import ========= //
import { 
    FmSection_1, 
    FmHowItsWorks, 
    FmLowTco, 
    FmPricing 
} from './component';
const FullyManaged = () => {
    const location = useLocation();
    // useEffect(() => {
    //   const scrollToHash = () => {
    //     if (location.hash) {
    //       const id = location.hash.substring(1);
    //       const element = document.getElementById(id);
    //       if (element) {
    //         const elementTop = element.getBoundingClientRect().top + window.scrollY;
    //         window.scrollTo({
    //           top: elementTop - 100,
    //           behavior: 'smooth',
    //         });
    //       }
    //     } else {
    //       window.scrollTo({ top: 0, behavior: 'smooth' });
    //     }
    //   };
  
    //   // Delay to allow DOM rendering
    //   setTimeout(scrollToHash, 100);
    // }, [location.pathname, location.hash]);
    useEffect(() => {
      if (location.hash) {
          const element = document.getElementById(location.hash.substring(1));
          if (element) {
              const elementTop = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                  top: elementTop - 100,
                  behavior: 'smooth'
              });
          }
      }
      else{
          window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, [location]);  

    return (
        <>
            <section className="hero-area hero-area-background">
                <FmSection_1/>
            </section>
            <section className='mt-20'>
                <div className="container">
                    <div id="how-its-works">
                        <FmHowItsWorks />
                    </div>
                    <div id="low-tco">
                        <FmLowTco/>
                    </div>
                    <div id="pricing">
                        <FmPricing />
                    </div>
                </div>
            </section>
        </>
    )
}

export {FullyManaged}